import { render, staticRenderFns } from "./UpdateLoanStatus.vue?vue&type=template&id=79a9cfcc"
import script from "./UpdateLoanStatus.vue?vue&type=script&lang=js"
export * from "./UpdateLoanStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports